import { type ExamEventData } from '@exam-center/exam-event-management';
import { type SearchTimeExtendedExamEventSessionExamineesQuery } from '@exam-center/graphql';

import { type TimeExtensionHistoryRow } from '../../components';
import { calculateGrantedManualDurationInMs } from '../../utils';

export function mapTimeExtendedExamEventSessionExamineesToTimeExtensionHistoryRows(
  extendedExamEventSessionExaminee:
    | SearchTimeExtendedExamEventSessionExamineesQuery['ecSearchTimeExtendedExamEventSessionExaminees']['extendedExamEventSessionExaminees']
    | undefined,
  courses: ExamEventData['courses'],
): TimeExtensionHistoryRow[] {
  if (!extendedExamEventSessionExaminee) return [];

  const maxExtendableByCourseSession = new Map<string, number>();
  for (const course of courses ?? []) {
    const courseId = course.examCourse?.id;
    if (!courseId) continue;
    for (const adj of course.metadata?.sessionTimeAdjustments ?? []) {
      maxExtendableByCourseSession.set(
        `${courseId}::${adj.sessionId}`,
        adj.maxExtendableDurationInMs,
      );
    }
  }

  return extendedExamEventSessionExaminee.map((item) => {
    const {
      id,
      examEventSessionId,
      autoExtendDurationInMs,
      timeExtensionRemark,
      totalExtendedDurationInMs,
    } = item;
    const { firstName, middleName, lastName } = item.examinee;
    const seatNumber = item.examEventExaminee.seatNumber;
    const examCourseCode = item.examEventExaminee.examCourse.code;
    const { examCourseId } = item.examEventExaminee;

    const maxExtendable =
      maxExtendableByCourseSession.get(`${examCourseId}::${examEventSessionId}`) ??
      Number.POSITIVE_INFINITY;
    const manualExtendedDurationInMs = totalExtendedDurationInMs - (autoExtendDurationInMs ?? 0);

    return {
      id,
      firstName,
      examCourseCode,
      middleName: middleName ?? '',
      lastName,
      seatNumber: seatNumber?.toString() ?? '-',
      manualExtendedDurationInMs: calculateGrantedManualDurationInMs({
        rawManual: manualExtendedDurationInMs ?? 0,
        rawAuto: autoExtendDurationInMs ?? 0,
        maxExtendable,
      }),
      autoExtendedDurationInMs: autoExtendDurationInMs ?? 0,
      remark: timeExtensionRemark ?? '-',
    };
  });
}
